import React from 'react';
import sha256 from 'sha256';
import Navbar from '../navbar';
import queryString from 'query-string';

import { Alert } from 'reactstrap';
import { isModernApi } from '../../index';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.submitLogin = this.submitLogin.bind(this);
    this.state = { origin: null };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const parsed = queryString.parse(this.props.location.search);
    const error = parsed.error ? parsed.error : null;
    this.setState({
      origin: parsed.origin,
      error
    });
  }

  handleChange(event) {
    this.setState({
      ...this.state,
      login: {
        ...this.state.login,
        [event.target.id]: event.target.value
      }
    });
  }

  async submitLogin(event) {
    if (!event.target.checkValidity()) {
      this.setState({
        ...this.state,
        wasValidated: true
      });
      window.scrollTo(0, 0);
      return;
    }
    const data = new FormData(event.target);
    fetch(
      isModernApi()
        ? 'https://docmanagement.parchment.com/v1/api/archive/external/login'
        : 'https://externalview.scribonline.com/login',
      {
        method: 'POST',
        body: data
      }
    );
  }

  render() {
    let message = null;
    if (this.state.loginFailure) {
      message = (
        <div className="alert alert-danger" role="alert">
          Sign In Failed
        </div>
      );
    }
    return (
      <div style={{ height: '100%', minHeight: '100%' }}>
        <Navbar hideLogout={true} />
        <div
          style={{ maxWidth: '450px', margin: '0 auto', paddingTop: '100px' }}
        >
          <Alert color="info">Welcome!</Alert>
          <form
            method="POST"
            action={
              isModernApi()
                ? 'https://docmanagement.parchment.com/v1/api/archive/external/login'
                : 'https://externalview.scribonline.com/login'
            }
          >
            {message}
            <div className="form-group">
              <div className="col-xs-12">
                <label htmlFor="inputEmail" className="sr-only">
                  User Name
                </label>
                <input
                  type="text"
                  name="username"
                  id="username"
                  className="form-control form-control-lg"
                  placeholder="username"
                  required
                  autoFocus=""
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <div className="form-group">
              <div className="col-xs-12">
                <label htmlFor="inputPassword" className="sr-only">
                  Password
                </label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  className="form-control form-control-lg"
                  placeholder="Password"
                  required
                  onChange={this.handleChange}
                />
              </div>
            </div>
            <input
              type="hidden"
              id="origin"
              name="origin"
              value={this.state.origin}
            />
            {this.state.error && (
              <div className="form-group">
                <div className="col-xs-12">
                  <div className="alert alert-danger">
                    Incorrect username or password
                  </div>
                </div>
              </div>
            )}
            <div className="form-row">
              <div className="form-group col-xs-5">
                <button
                  className="btn btn-md btn-primary btn-block"
                  style={{ width: '120px' }}
                  type="submit"
                >
                  Sign In
                </button>
              </div>
              <div className="form-group col-xs-7" style={{ width: '71%' }}>
                <img
                  alt="logo"
                  width="150px"
                  className="float-right"
                  src="/images/inst-parchment-logo-color.png"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}
//{ console.log(props.location.state.from.pathname)}

export default Login;
